export default {
  computed: {
    disclaimers() {
      let isInCompareMode = this.$route.params.mode === 'compare'

      let cubeIds = [this.$store.state.query.mainCubeId]

      if (isInCompareMode) {
        cubeIds = cubeIds.concat([
          this.$store.state.query.pairCubeId,
          this.$store.state.query.sizeCubeId,
        ])
      }

      cubeIds = new Set(cubeIds.filter(v => v))

      let countryIds = this.$store.getters.mainAvailableCountries

      if (isInCompareMode) {
        countryIds = countryIds.concat(this.$store.getters.pairAvailableCountries)

        if (this.$store.getters.sizeCountryDimension) {
          countryIds = countryIds.concat(this.$store.getters.sizeAvailableCountries)
        }
      }

      countryIds = new Set(countryIds.filter(v => v))

      let indIds = [
        [this.$store.state.query.mainCubeId, this.$store.state.query.mainIndId],
        [this.$store.state.query.pairCubeId, this.$store.state.query.pairIndInd],
        [this.$store.state.query.sizeCubeId, this.$store.state.query.sizeIndId],
      ]

      indIds = new Set(indIds.filter(t => t[0] && t[1]).map(t => t.join('-')))

      return this.$store.getters.disclaimer(cubeIds, countryIds, indIds)
    },
    printDisclaimers() {
      const template = document.createElement('template')
      return this.disclaimers.map(note => {
        template.innerHTML = note.value
        return { key: note.key, value: template.content.textContent }
      })
    },
    exportSources() {
      return this.$store.state.external.exportSources.filter(
        el => el.key == this.$store.state.query.mainCubeId
      )
    },
  },
}
